<template>
    <b-card>
        <!-- Details Dialog -->
        <b-card-header>
            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows / itemsPerPage) }} Total:
                {{ rows }}
            </p>
            <b-row>
                <b-col md="2" cols="12">
                    <b-button-group>
                        <b-button variant="light" size="sm" @click="shouldShowFilters = !shouldShowFilters">
                            <span style="white-space: nowrap">
                                Filters
                                <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                    }`"></b-icon>
                            </span>
                        </b-button>
                        <b-button variant="light" size="sm" @click="resetFilters" v-b-tooltip.hover
                            title="Reset Filters">
                            <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                        </b-button>
                    </b-button-group>
                </b-col>

                <b-col class="text-right mb-2">
                    <slot></slot>
                </b-col>
            </b-row>

            <AssetServiceQueryFilter class="mt-12" :date-range="dateRangeIdx" v-show="shouldShowFilters"
            ref="queryFilter" v-model="filters" :disabled-officers="!hasPermissionView" />
        </b-card-header>
        <b-card-body>
            <!-- <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p> -->
            <b-table :fields="asset_order_fields"  :per-page="itemsPerPage"
            :current-page="currentPage" striped hover responsive :items="items" :busy="loading">
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(id)="{ item: order, index }">
                    <b-button :key="index + 'rootbutton'" size="sm" :to="`/admin/orders/${order.id}`"
                        class="mr-2" variant="primary" v-if="hasPermissionView">
                        View Activity
                    </b-button>
                </template>

                <template #cell(driver_id)="{ value }">
                    {{ getOfficerName(value) }}
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination class="float-right" v-model="currentPage" :total-rows="rows"
                        :per-page="itemsPerPage" aria-controls="roleTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import reportMixins from '@/mixins/reportMixins'
import popupMixins from '@/mixins/popupMixins'
import AssetServiceQueryFilter from './AssetServiceQueryFilter.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
import moment from 'moment'

const defaultFilters = Object.freeze({
    completion_date_from: null,
    completion_date_to: null,
    status: null,
    due_from: null, // moment().startOf('month').format('YYYY-MM-DD'),
    due_to: null, // '9999-01-01', // moment().endOf('month').format('YYYY-MM-DD'),
})
const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}
export default {
    name: 'assets-itemList',
    components: { AssetServiceQueryFilter },
    props: [
        'id',
        'items',
        'rows',
        'title',
    ],
    mixins: [popupMixins, permissionsMixins,reportMixins],
    data() {
        return {
            query: '',
            reportType: 'service_item_details',
            itemsPerPage: 1,
            currentPage: 1,
            shouldShowFilters: false,
            dateRangeIdx: 2,
            loading: false,
            filters: { ...defaultFilters },
        }
    },

    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        
        officers() {
            return this.$store.getters['users/sorted_officers']
        }, 
        queryModel() {
            const { query } = this
            return { query, ...this.filters }
        },
        asset_order_fields() {
            return [
                {
                    key: 'id',
                    label: 'Action',
                },
                {
                    key: 'reference_no',
                    label: 'Reference Number',
                    formatter: value => value,
                },
                'description',
                {
                    key: 'status',
                    label: 'Status',
                    formatter: (value, key, item) =>
                        item.completed == 1
                            ? 'Completed'
                            : item.released == 1
                                ? 'Released'
                                : 'Pending',
                },
                {
                    key: 'schedule_at',
                    label: 'Due Date',
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },

                {
                    key: 'completed_at',
                    label: 'Completion Date',
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },
                {
                    key: 'driver_id',
                    label: 'Assigned To ',
                },


            ]
        },
    },

    watch: {
        report_loading: function (val) {
            this.$emit('report-state', val)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        dateRangeIdx: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.$set(
                        this.filters,
                        'due_from',
                        moment().format('YYYY-MM-DD')
                    )
                    this.$set(
                        this.filters,
                        'due_to',
                        moment().format('YYYY-MM-DD')
                    )
                    break
                //due_to: moment().endOf('month').format('YYYY-MM-DD'),
                case dateRangeEnum.yesterday:
                    this.$set(
                        this.filters,
                        'due_from',
                        moment().subtract(1, 'days').format('YYYY-MM-DD')
                    )
                    this.$set(
                        this.filters,
                        'due_to',
                        moment().subtract(1, 'days').format('YYYY-MM-DD')
                    )
                    break
                default:
                    break
            }
            this.clearSelected()
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    methods: {
        getQueryString(rpt_type) {
            const queryModel = {}
            queryModel.name = this.query
            queryModel.rpt_type = rpt_type
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },
        getOfficerName(id) {
            const officer = this.officers.find(x => x.id == id)
            if (!officer) return ''
            return officer.name
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD HH:mm'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        resetFilters() {
            this.filters = { ...defaultFilters }
            this.doSearch()
        },
        doSearch() {
            console.log("id",this)
            try {
                this.loading = true
                const id = this.id
                let {
                    query,
                    filters,
                    // pagination: { page },
                } = this
                // page = parseInt(page) || 1
                // this.tableLoading = true
                this.$router.push({
                    query: { query, ...filters },
                })
                this.$store.dispatch('assets/fetchServiceHistory', {
                    query,
                    filters,
                    id
                }).then(() => {
                    this.loading = false
                })

                // })
            } catch (err) {
                console.error('loading error', err)
            }
        },

       
        //     try {
        //         this.loading = true
        //         const {
        //             query,
        //             pagination: { page },
        //             filters,
        //             crm,
        //             crmSettingValue: { type_id },
        //         } = this

        //         if (crm) {
        //             this.$set(filters, 'type_id', type_id || null)
        //             this.$set(filters, 'warranty_from', null)
        //             this.$set(filters, 'warranty_to', null)
        //         } else if (doReset) {
        //             this.$set(filters, 'type_id', null)
        //         }

        //         this.$set(filters, 'crm_type_id', type_id || null)

        //         await this.$store.dispatch('assets/fetch', {
        //             query,
        //             page,
        //             filters,
        //         })
        //     } catch (err) {
        //         console.error('loading error', err)
        //     } finally {
        //         this.loading = false
        //     }
        // },
       
    },
}
</script>
<style></style>
